const appErrorProbeLang = {
	title: {
		tag: 'app.error_probe.title',
		fr: 'Désolé... en maintenance',
		en: 'Sorry... in maintenance',
	},
	content: {
		tag: 'app.error_probe.content',
		fr: "L'application est actuellement en cours de maintenance, elle sera bientôt accessible avec de meilleures fonctionnalités.",
		en: 'The application is currently under maintenance, it will soon be available with better features.',
	},
	backToMainPage: {
		tag: 'app.error_probe.back_to_main_page',
		fr: 'Retour à la page principale',
		en: 'Back to main page',
	},
	pageDoesntExist: {
		tag: 'app.error_probe.page_doesnt_exist',
		fr: "La page demandée n'existe pas",
		en: "Sorry, this page doesn't exist",
	},
};

export default appErrorProbeLang;
